(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-celebration-product]').forEach((page) => {
      if (page.dataset.celebrationInitialized) return;
      page.dataset.celebrationInitialized = 'true';
      const gallery = page.querySelector('[data-product-gallery]');
      const stage = gallery?.querySelector('.tis-product-gallery__main');
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      let revealTimer;
      const reveal = () => {
        if (!stage || reducedMotion.matches) return;
        clearTimeout(revealTimer);
        stage.classList.remove('is-celebration-revealing');
        void stage.offsetWidth;
        stage.classList.add('is-celebration-revealing');
        revealTimer = setTimeout(() => stage.classList.remove('is-celebration-revealing'), 480);
      };
      gallery?.addEventListener('click', (event) => {
        if (event.target.closest('[data-gallery-thumbnail], [data-gallery-prev], [data-gallery-next]')) reveal();
      });
      stage?.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') reveal();
      });

      const form = page.querySelector('[data-product-form]');
      const submit = form?.querySelector('[data-add-to-cart], button[type="submit"]');
      const dock = page.querySelector('[data-celebration-dock]');
      const proxy = dock?.querySelector('[data-celebration-dock-submit]');
      if (!form || !submit || !dock || !proxy || !('IntersectionObserver' in window)) return;
      const originalError = form.querySelector('[data-product-form-error]');
      const dockError = dock.querySelector('[data-celebration-dock-error]');
      const mobile = matchMedia('(max-width: 760px)');
      let originalVisible = true;
      const reserveSpace = () => {
        const height = !dock.hidden ? Math.ceil(dock.getBoundingClientRect().height) : 0;
        document.documentElement.style.setProperty('--tis-celebration-dock-height', `${height}px`);
      };
      const syncVisibility = () => {
        dock.hidden = !mobile.matches || originalVisible;
        reserveSpace();
      };
      const syncForm = () => {
        proxy.disabled = submit.disabled || submit.getAttribute('aria-disabled') === 'true';
        proxy.textContent = submit.textContent.trim();
        if (submit.hasAttribute('aria-busy')) proxy.setAttribute('aria-busy', submit.getAttribute('aria-busy'));
        else proxy.removeAttribute('aria-busy');
        if (dockError) {
          dockError.textContent = originalError?.textContent || '';
          dockError.hidden = !originalError || originalError.hidden || !originalError.textContent.trim();
        }
        reserveSpace();
      };
      proxy.addEventListener('click', () => {
        syncForm();
        if (!proxy.disabled) form.requestSubmit(submit);
        syncForm();
      });
      const formObserver = new MutationObserver(syncForm);
      formObserver.observe(form, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'hidden'] });
      const visibilityObserver = new IntersectionObserver(([entry]) => {
        originalVisible = entry.isIntersecting;
        syncVisibility();
      });
      visibilityObserver.observe(submit);
      mobile.addEventListener('change', syncVisibility);
      const sizeObserver = 'ResizeObserver' in window ? new ResizeObserver(reserveSpace) : null;
      sizeObserver?.observe(dock);
      syncForm();
      syncVisibility();
      document.addEventListener('shopify:section:unload', (event) => {
        if (!event.target.contains(page)) return;
        formObserver.disconnect();
        visibilityObserver.disconnect();
        sizeObserver?.disconnect();
        mobile.removeEventListener('change', syncVisibility);
        clearTimeout(revealTimer);
        document.documentElement.style.setProperty('--tis-celebration-dock-height', '0px');
      });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
